import { Messages } from "../../../../constant/messages/toastMessages";
import { colors, palette, sp, fs, lh } from "../../../../styles/design-tokens";

const MaintenancePage = (props: any) => {
  const { isCorsError } = props;

  // const handleRefresh = () => {
  //   window.location.reload();
  // };
  let messageTitle = Messages["maintenance.message"].messageTitle;
  let subTitle = Messages["maintenance.message"].message.split(",")[0].trim();
  let message = Messages["maintenance.message"].message.split(",")[1].trim();

  if (isCorsError) {
    messageTitle = Messages["maintenance.corsError"].messageTitle;
    subTitle = Messages["maintenance.corsError"].message.split(",")[0].trim();
    message = Messages["maintenance.corsError"].message.split(",")[1].trim();
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: sp(20),
        textAlign: "center",
        fontFamily: "var(--brand-font-body)",
      }}
    >
      <h2 style={{ marginBottom: sp(20), color: palette["gray-20"] }}>{messageTitle}</h2>
      <p
        style={{
          marginBottom: sp(10),
          fontSize: fs(16),
          color: colors.neutral.base,
          maxWidth: "500px",
          lineHeight: lh(1.5),
          fontFamily: "var(--brand-font-body)",
        }}
      >
        {subTitle}
      </p>
      <p
        style={{
          marginBottom: sp(30),
          fontSize: fs(16),
          color: colors.neutral.base,
          maxWidth: "500px",
          lineHeight: lh(1.5),
          fontFamily: "var(--brand-font-body)",
        }}
      >
        {message}
      </p>
      {/* <AppButton 
        onClick={handleRefresh}
      >
        Refresh Page
      </AppButton> */}
    </div>
  );
};

export default MaintenancePage;
